import { SET_PII } from '../actions/types';

export default function pii(state = [], action) {
	if (!action.error && action.payload !== undefined) {
		switch (action.type) {
			case SET_PII:
				return action.payload;

			// no default
		}
	}

	return state;
}
